

















































































































import Vue from 'vue'

export default Vue.extend({
  name: 'LoanOriginatorPage',
  props: {
    id: { type: String, required: true },
  },
  data() {
    return {
      loading: true,
      loanOriginators: [],
    }
  },
  watch: {
    id: {
      immediate: true,
      handler() { this.fetch() },
    },
  },
  methods: {
    fetch() {
      this.loading = true
      this.$http
        .get(`/loan_originators/?common_name=${this.id}`)
        .then((response) => {
          this.loading = false
          this.loanOriginators = response.data.results
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
})
